<nb-card>
	<nb-card-header>
		<button
			*ngIf="!showAddCard"
			(click)="showAddCard = !showAddCard"
			nbButton
			status="success"
		>
			<nb-icon class="mr-1" icon="plus-outline"></nb-icon
			>{{ 'BUTTONS.ADD' | translate }}
		</button>
		<div *ngIf="showAddCard" class="row m-0">
			<form [formGroup]="form" *ngIf="form" class="col">
				<ng-select
					id="departmentsSelect"
					[hideSelected]="true"
					multiple="true"
					bindLabel="name"
					appendTo="body"
					formControlName="departments"
					[placeholder]="placeholder"
					fullWidth
				>
					<ng-option
						*ngFor="let entity of organizationEntities"
						value="{{ entity.id }}"
						>{{ entity.name }}</ng-option
					>
				</ng-select>
			</form>
			<span class="col-2 pl-2 pr-1"
				><button
					class="w-100"
					(click)="submitForm()"
					nbButton
					status="success"
					[disabled]="!form.valid"
				>
					{{ 'BUTTONS.ADD' | translate }}
				</button></span
			>
			<span class="col-2 pl-1 pr-0"
				><button
					class="w-100"
					(click)="showAddCard = !showAddCard"
					nbButton
					status="danger"
				>
					{{ 'BUTTONS.CANCEL' | translate }}
				</button>
			</span>
		</div>
	</nb-card-header>
	<nb-card-body *ngIf="employeeEntities?.length">
		<div class="ml-3 mb-4">
			<strong>{{ title }}</strong>
		</div>
		<nb-card *ngFor="let d of employeeEntities">
			<nb-card-body>
				{{ d.name }}
				<nb-actions class="float-right" e="medium">
					<nb-action
						(click)="removeDepartment(d.id)"
						class="d-inline pr-0"
						icon="close"
					></nb-action>
				</nb-actions>
			</nb-card-body>
		</nb-card>
	</nb-card-body>
</nb-card>
